export default {
  props: {
    process: {
      type: String,
      default: 'ready' // ready uploading success fail
    }
  }
  /* watch: {
    process() {
      console.log('process ', this.process);
    },
  }, */
};